interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "max-w-2xl mx-auto text-center" : "max-w-2xl"}>
      <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 font-label text-xs font-medium tracking-wide text-secondary-900">
        <span className="w-1.5 h-1.5 rounded-full bg-accent-500" aria-hidden="true"></span>
        {eyebrow}
      </span>
      <h2 className="mt-4 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
        {title}
      </h2>
      {description ? (
        <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
          {description}
        </p>
      ) : null}
    </div>
  );
}